// WHERE PHASE 7'S CALL IS DRAWN: over its subphase selector (AssemblySubphases), by the sub-step
// on screen (AssemblyPhase). Its own file so the two can share it without importing each other.
export const ASSEMBLY_CALL_SLOT_ID = 'assembly-call-slot';
